import React from 'react';
import '../styles/ServicesPage.css';

const ServicesPage = () => {
  const services = [
    {
      id: 'pr',
      title: 'PR',
      description: 'Kurumsal iletişim stratejileri ve medya ilişkileri yönetimi ile markanızın itibarını güçlendiriyoruz.',
      link: '/hizmetlerimiz/pr'
    },
    {
      id: 'sosyal-medya',
      title: 'Sosyal Medya',
      description: 'Dijital platformlarda markanızın sesini duyuruyor, etkileşimi artırıyor ve topluluk yönetimi sağlıyoruz.',
      link: '/hizmetlerimiz/sosyal-medya'
    },
    {
      id: 'produksiyon',
      title: 'Prodüksiyon',
      description: 'Profesyonel ekipmanlar ve yaratıcı ekibimizle markanız için etkileyici görsel içerikler üretiyoruz.',
      link: '/hizmetlerimiz/produksiyon'
    },
    {
      id: 'organizasyon',
      title: 'Organizasyon',
      description: 'Lansman, basın toplantısı ve kurumsal etkinliklerinizi A\'dan Z\'ye planlıyor ve yönetiyoruz.',
      link: '/hizmetlerimiz/organizasyon'
    },
    {
      id: 'studyo-hizmeti',
      title: 'Stüdyo Hizmeti',
      description: 'Modern ekipmanlar ve profesyonel ekibimizle stüdyo çekimleriniz için ideal ortam sağlıyoruz.',
      link: '/hizmetlerimiz/studyo-hizmeti'
    }
  ];

  return (
    <div className="services-page">
      <section className="services-hero">
        <div className="container">
          <h1>Hizmetlerimiz</h1>
          <p className="services-description">
            5N1PR olarak, markanızın ihtiyaçlarına özel çözümler sunuyoruz. 
            Aşağıdaki hizmetlerimizden size uygun olanı seçerek detaylı bilgi alabilirsiniz.
          </p>
        </div>
      </section>
      
      {/*<section className="services-interactive">
        <div className="container">
          <InteractiveLogoSVG />
        </div>
      </section>*/}
      
      <section className="services-list">
        <div className="container">
          <div className="services-grid">
            {services.map((service) => (
              <div className="service-card" key={service.id}>
                <h2>{service.title}</h2>
                <p>{service.description}</p>
                <a href={service.link} className="btn btn-primary">Detaylı Bilgi</a>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      <section className="services-approach">
        <div className="container">
          <div className="approach-content">
            <h2>Çalışma Yaklaşımımız</h2>
            <p>
              5N1PR olarak, her projeye özgün bir yaklaşımla başlıyor, markanızın değerlerini ve hedeflerini 
              derinlemesine anlayarak size özel stratejiler geliştiriyoruz. Deneyimli ekibimiz, yaratıcı 
              çözümlerimiz ve sonuç odaklı yaklaşımımızla fark yaratıyoruz.
            </p>
            <p>
              Müşterilerimizle kurduğumuz şeffaf ve güvene dayalı ilişkiler, uzun vadeli başarıların 
              temelini oluşturuyor. Her adımda sizinle birlikte ilerliyor, sürekli iletişim halinde 
              kalarak beklentilerinizi en üst düzeyde karşılıyoruz.
            </p>
          </div>
        </div>
      </section>
      
      <section className="contact-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Projeleriniz İçin Bizimle İletişime Geçin</h2>
            <p>
              Markanızı bir sonraki seviyeye taşımak için hazırız. 
              Hemen iletişime geçin ve projeleriniz hakkında konuşalım.
            </p>
            <a href="/iletisim" className="btn btn-primary">İletişime Geç</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
